import { render, staticRenderFns } from "./BookingInfoCard.vue?vue&type=template&id=6e7e665e&scoped=true&"
import script from "./BookingInfoCard.vue?vue&type=script&lang=ts&"
export * from "./BookingInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingInfoCard.vue?vue&type=style&index=0&id=6e7e665e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e665e",
  null
  
)

export default component.exports